import React, { useState, useEffect } from "react";
import "../pages/styles.css";
import Header from "../components/header";
import img1 from "../assets/logo_maker/1.png";
import img2 from "../assets/logo_maker/2.png";
import img3 from "../assets/logo_maker/3.webp";

import img44 from "../assets/logo_maker/44.webp";
import img45 from "../assets/logo_maker/45.webp";
import img46 from "../assets/logo_maker/46.png";

import {
  LazyLoadComponent,
  LazyLoadImage,
} from "react-lazy-load-image-component";
import img7 from "../assets/promotionmaker/6.webp";
import img8 from "../assets/promotionmaker/7.webp";
import img9 from "../assets/promotionmaker/8.webp";

import Button from "@mui/material/Button";
import axios from "axios";
import Footer from "../components/Footer";

import { useSelector, useDispatch } from "react-redux";
import { loginModal } from "../Redux/authAction";
import { NavLink } from "react-router-dom";
import apiConfig from '../config/api.js';

const LogoMaker = () => {
  const [data, setData] = useState([]);
  const [img, setImg] = useState(`${img1}`);
  const isLang = useSelector((state) => state.authReducer.lang);

  const isAuthenticated = useSelector(
    (state) => state.authReducer.isAuthenticated
  );
  const dispatch = useDispatch();

  const handleOpen = () => {
    dispatch(loginModal(true));
    setOpenModel(false);
  };
  const handelOpenModel = () => {
    dispatch(loginModal(false));
    setOpenModel(true);
  };
  const handleClose = () => {
    dispatch(loginModal(false));
    dispatch(loginModal(false));
  };
  const handleCloseModel = () => setOpenModel(false);
  const [openModel, setOpenModel] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${apiConfig.API_URL}/aapi/tempbycat.php?title=Logo Maker`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log("data-=-=-=-", data);
  return (
    <>
      <Header />
      <div className="pt-20 bg-purple-500">
      <div className={`grid grid-cols-2 p-5`}>
  <div className={`p-10 ml-5 text-white text-[16px] font-[100px] ${isLang === 'eng' ? 'text-left' : 'text-right'}`}>
    {isLang === 'eng' ? (
      <>
        <p className="text-4xl font-semibold text-center">
          Craft your ideal logo in minutes with us
        </p>
        <br />
        <p>
          With Maker4U Logo Maker, you can bring your vision to life with just a few clicks. Simply enter your business name, and watch as our Logo Maker works its magic, creating a range of eye-catching designs tailored to your brand.
          <br /> <br />
          But we don't stop there. Want a logo that reflects your industry or style? No problem. Maker4U Logo Maker lets you refine your search with specific keywords, ensuring you find the perfect design that truly embodies your business.
          <br /> <br />
          With thousands of logos at your fingertips, finding the one that speaks to your brand has never been easier. Say goodbye to generic designs and hello to a logo that sets you apart from the competition.
          <br /> <br />
          Experience the expertise of our Logo Maker today and take the first step towards building a memorable brand identity that leaves a lasting impression.
        </p>
      </>
    ) : (
      <>
        <p className="text-4xl font-semibold text-center">
          اصنع شعارك المثالي في دقائق معنا
        </p>
        <br />
        <p>
          مع صانع الشعارات Maker4U ، يمكنك تجسيد رؤيتك ببضع نقرات. فقط قم بإدخال اسم مشروعك، وشاهد صانع الشعارات الخاص بنا وهو يعمل بسحره، ويبتكر مجموعة من التصاميم الجذابة المصممة خصيصًا لعلامتك التجارية.
          <br /> <br />
          ولكن هذا ليس كل شيء. هل تريد شعارًا يعكس صناعتك أو أسلوبك؟ لا مشكلة. يتيح لك صانع الشعارات Maker4U تحسين بحثك باستخدام كلمات رئيسية محددة، مما يضمن لك العثور على التصميم المثالي الذي يجسد مشروعك بحق.
          <br /> <br />
          مع وجود آلاف الشعارات في متناول يدك، اصبح العثور على الشعار الذي يصف علامتك التجارية أسهل من أي وقت مضى. قل وداعًا للتصاميم المملة، ومرحبًا بشعار يميزك عن المنافسة.
          <br /> <br />
          جرّب خبرة صانع الشعارات الخاص بنا اليوم واتخذ الخطوة الأولى نحو بناء هوية علامة تجارية لا تُنسى وتترك انطباعًا دائمًا.
        </p>
      </>
    )}
  </div>

  <div>
    <LazyLoadImage src={`${img1}`} className="w-full h-full px-4" />
  </div>
</div>

      </div>
      <div className="text-center mt-10">
  <p className="text-[32px] font-[500]">
    {isLang === 'eng' ? 'Free Logo Maker' : 'صانع الشعارات المجاني'}
  </p>

  <div className="flex justify-center mt-5">
    <div className="text-center" style={{ maxWidth: "840px" }}>
      <p style={{fontSize:"16px"}}>
        {isLang === 'eng' ? (
          <>
            Ready to create a professional logo that truly captures the essence
            of your brand?
            <br /> <br />
            Maker4U's intuitive online platform empowers you to create a logo that perfectly represents your brand identity. Whether you're a seasoned designer or new to logo creation, our user-friendly interface ensures a seamless experience every step of the way. Our Free Logo Maker is here to make it happen effortlessly.
            <br /> <br />
            But that's not all. Once you've created your perfect logo, download it for free in high-quality files ready to be used on your website, business cards, social media, and more. Say goodbye to limitations and hello to endless possibilities for showcasing your brand.
            <br /> <br />
            Empower your brand with a logo that speaks volumes about who you are and what you stand for. Try our Free Logo Maker today and take the first step towards making a lasting impression in the minds of your audience.
          </>
        ) : (
          <>
            هل أنت جاهز لإنشاء شعار احترافي يجسد جوهر علامتك التجارية؟
            <br /> <br />
            تتيح لك منصة Maker4U عبر الإنترنت إنشاء شعار يمثل هوية علامتك التجارية. سواء كنت مصممًا متمرسًا أو جديدًا في إنشاء الشعارات، فإن واجهتنا سهلة الاستخدام تضمن تجربة سلسة في كل خطوة. إن أداة إنشاء الشعارات المجانية لدينا موجودة هنا لتحقيق ذلك دون عناء.
            <br /> <br />
            ولكن هذا ليس كل شيء. بمجرد إنشاء شعارك المثالي، قم بتنزيله مجانًا في ملفات عالية الجودة جاهزة للاستخدام على موقع الويب الخاص بك، بطاقات العمل، وسائل التواصل الاجتماعي والمزيد من ذلك. قل وداعًا للقيود ومرحبًا بالإمكانيات التي لا نهاية لها لعرض علامتك التجارية.
            <br /> <br />
            قم بتقوية علامتك التجارية بشعار يعكس هويتك وما تمثله. قم بتجربة أداة إنشاء الشعارات المجانية اليوم واتخذ الخطوة الأولى نحو ترك انطباع دائم في أذهان جمهورك.
          </>
        )}
      </p>
    </div>
  </div>
</div>

      <div
        className="card-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        
        {data.map((item) => (
     
          <div key={item.id} className="card">
            <LazyLoadImage
              src={`${apiConfig.API_URL}/aapi/templetes/${item.imagepath}`}
              alt={item.title}
            />
            <div className="card-content">
              <h3>{item.title}</h3>
              
            </div>
          </div>
        )
        )}
      </div>
 
    <NavLink
      to="/resumeMaker/temp/Logo Maker">
      <Button
        variant="contained"
        onClick={handleOpen}
        style={{
          margin: "auto",
          display: "block",
          borderRadius: "20px",
          width: "180px",
          backgroundColor:
            "#882ED8",
        }}
      >
        SHOW MORE
      </Button>
      </NavLink>

      <p className="my-16 text-[32px] text-center font-[500]">
  {isLang === 'eng' ? 'Personalize your logo' : 'قم بتخصيص شعارك'}
</p>


      <div className="imageGrid">
        <div>
          <LazyLoadImage src={`${img2}`} />
        </div>
        <div>
          <div onClick={() => setImg(`${img2}`)}>
            <LazyLoadImage src={`${img2}`} />
          </div>
          <div onClick={() => setImg(`${img3}`)}>
            <LazyLoadImage src={`${img3}`} />
          </div>
          <div onClick={() => setImg(`${img44}`)}>
            <LazyLoadImage src={`${img44}`} />
          </div>
        </div>
      </div>

      <div className="catelogTextContainer">
  <div className="catelogText">
    <p style={{ fontSize: "16px" }}>
      {isLang === 'eng' ? (
        <>
          Adjusting colors, fonts, and layout is as simple as a few clicks,
          allowing you to effortlessly align your logo with your unique
          aesthetic. Move the logo icon, tweak spacing, or refine the layout
          with ease, thanks to our intuitive tools designed to streamline the
          design process.
          <br />
          <br />
          But wait, there's more. Dive deeper into customization by
          experimenting with gradient colors, incorporating additional shapes,
          or adding curved text for a truly bespoke look. With Maker4U logo
          maker tool, the possibilities are endless, ensuring you can create a
          logo that not only represents your brand but also stands out from
          the crowd.
        </>
      ) : (
        <>
          يمكنك ضبط الألوان والخطوط والتخطيط ببضع نقرات بسيطة، حيث يمكنك
          محاذاة شعارك مع تصميمك الجمالي الفريد دون عناء. يمكنك تحريك أيقونة
          الشعار أو تعديل المسافات أو تحسين التخطيط بسهولة، وذلك بفضل أدواتنا
          البديهية المصممة لتبسيط عملية التصميم.
          <br />
          <br />
          ولكن لحظة، لدينا المزيد. انغمس اكثر في التخصيص من خلال تجربة الألوان
          المتدرجة، دمج الأشكال الإضافية وإضافة نص منحني للحصول على مظهر مخصص
          حقًا. باستخدام أداة صانع الشعار Maker4U، فإن الاحتمالات لا حصر لها،
          مما يضمن لك إمكانية إنشاء شعار لا يمثل علامتك التجارية فحسب، بل
          يبرز أيضًا من بين الحشود.
        </>
      )}
    </p>
    {/* <Button onClick={handleOpen} variant="contained" style={{marginTop:"10px",width:"180px", borderRadius:"30px", background:  "linear-gradient(to right, #714e91 0%, #5f619f  51%, #433761  100%"}}>Try Now</Button> */}
  </div>
</div>

<div className={`catlogSection ${isLang === 'ara' ? 'flex flex-col-reverse md:flex-row-reverse' : 'flex flex-col md:flex-row'} p-5`}>
  <div className={`flex-shrink-0 ${isLang === 'ara' ? 'md:mr-6' : 'md:ml-6'} md:w-1/3`}>
    <LazyLoadImage src={`${img45}`} className="w-full h-auto" />
  </div>
  <div className="hidden md:block md:w-1/12"></div>
  <div className={`md:w-2/3 ${isLang === 'ara' ? 'md:ml-6' : 'md:mr-6'}`}>
    <p className="text-2xl md:text-3xl font-semibold mb-4">
      {isLang === 'eng' ? 'Craft a Professional Company Logo Reflecting Your Vision' : 'اصنع شعارًا احترافيًا يعكس رؤيتك لشركتك'}
    </p>
    <p className="text-base md:text-lg">
      {isLang === 'eng' ? (
        <>
          A stellar logo isn't just an accessory; it's the visual ambassador
          of your brand. It speaks volumes about your business ethos, values,
          and aspirations. At Maker4U, we understand the pivotal role a logo
          plays in your brand's identity, which is why our logo maker stands
          as a beacon of creativity and innovation.
          <br /><br />
          Whether you're in real estate, our diverse collection of logo
          templates caters to every business need. From modern and minimalist
          to bold and vibrant, Maker4U offers a range of styles to suit your
          brand's personality.
          <br /><br />
          Rest assured, with Maker4U by your side, you're not just creating a
          logo—you're crafting a symbol of your brand's essence and values.
          Experience the ease and creativity of logo design with Maker4U.
        </>
      ) : (
        <>
          الشعار المميز ليس مجرد إكسسوار، بل هو كالسفير البصري لعلامتك التجارية. فالشعار يتحدث كثيرًا عن أخلاقيات عملك وقيمك وتطلعاتك. في Maker4U، ندرك الدور المحوري الذي يلعبه الشعار في هوية علامتك التجارية، ولهذا السبب يقف صانع الشعار الخاص بنا كمنارة للإبداع والابتكار.
          <br /><br />
          سواء كنت تعمل في مجال العقارات، فإن مجموعتنا المتنوعة من نماذج الشعارات تلبي كل احتياجات العمل. من الحديث والبسيط إلى الجريء والحيوي، تقدم Maker4U مجموعة من الأنماط لتناسب شخصية علامتك التجارية.
          <br /><br />
          لكن الأمر لا ينتهي عند هذا الحد. تمنحك منصتنا إمكانية الوصول إلى مكتبة واسعة من الأيقونات والصور والأشكال والخطوط وعناصر التصميم، مما يسمح بتخصيص لا حدود له. مع Maker4U، لديك الحرية في تخصيص كل جانب من جوانب شعارك ليعكس هوية علامتك التجارية بدقة.
          <br /><br />
          كن مطمئنًا، مع Maker4U بجانبك، فأنت لا تقوم فقط بإنشاء شعار. بل تقوم بصياغة رمز لجوهر علامتك التجارية وقيمها. جرب سهولة وإبداع تصميم الشعار مع Maker4U.
        </>
      )}
    </p>
    {/* <Button variant="contained" onClick={handleOpen} className="mt-4 w-44 rounded-full bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-800 text-white">Try Now</Button> */}
  </div>
</div>



<div className={`catlogSectionTwo ${isLang === 'ara' ? 'flex flex-col-reverse md:flex-row-reverse' : 'flex flex-col md:flex-row'} p-5`}>
  <div className={`flex-shrink-0 ${isLang === 'ara' ? 'md:mr-6' : 'md:ml-6'} md:w-1/3`}>
    <LazyLoadImage src={`${img44}`} className="w-full h-auto" />
  </div>
  <div className="hidden md:block md:w-1/12"></div>
  <div className={`md:w-2/3 ${isLang === 'ara' ? 'md:ml-6' : 'md:mr-6'}`}>
    <p className="text-xl md:text-2xl font-semibold mb-4">
      {isLang === 'eng' ? 'Your business is your logo, your logo is your business' : 'مشروعك هو شعارك، شعارك هو مشروعك'}
    </p>
    <p className="text-base md:text-lg">
      {isLang === 'eng' ? (
        <>
          It's crucial to understand the significant relationship between your
          business and its logo. Your logo serves as the visual representation
          of your business, encapsulating its core values, identity, and
          aspirations. Conversely, your business relies on its logo to
          communicate these elements effectively to your audience.
          <br /><br />
          This symbiotic relationship is where creativity meets strategy,
          leaving a lasting impression on your customers. Ultimately, your
          logo is more than just a design—it's a vital component of your brand
          identity, reflecting your business and contributing to its overall
          success. Use Maker4U's logo maker template and create a perfect logo
          for your business or brand.
        </>
      ) : (
        <>
          من المهم أن تفهم العلاقة المهمة بين مشروعك وشعاره. يعمل شعارك كتمثيل مرئي لمشروعك، ويجسد قيمه الأساسية وهويته وتطلعاته. وعلى العكس من ذلك، يعتمد مشروعك على شعاره لتوصيل هذه العناصر بشكل فعال إلى جمهورك.
          <br /><br />
          هذه العلاقة التكافلية هي حيث يلتقي الإبداع بالاستراتيجية، مما يترك انطباعًا دائمًا لدى عملائك. في النهاية، شعارك هو ليس مجرد تصميم، بل عنصر حيوي لهوية علامتك التجارية، ويعكس مشروعك ويساهم في نجاحه. استخدم نموذج صانع الشعارات Maker4U وقم بإنشاء شعار مثالي لمشروعك أو علامتك التجارية.
        </>
      )}
    </p>
    {/* <Button className="mt-4 w-44 rounded-full bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-800 text-white">Try Now</Button> */}
  </div>
</div>


<div className="catlogSection">
  <div>
    <LazyLoadImage src={`${img1}`} />
  </div>
  <div></div>
  <div
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    {isLang === 'eng' ? (
      <div>
        <p  className="text-xl md:text-2xl font-semibold mb-4">Craft a stunning logo in just a few clicks.</p>
        <p style={{ fontSize: "16px" }}>
          In the fast-paced world of startups and new businesses, time is of the essence. That's why at Maker4U, we've designed our logo maker to be not only free but incredibly user-friendly. We understand the need for simplicity and efficiency, which is why we've dedicated countless hours perfecting our platform.
          <br />
          <br />
          With just a few clicks, you can access our extensive library of logo templates and customize them to suit your brand's personality. Whether you're a seasoned entrepreneur or just starting out, our intuitive interface makes the logo creation process a breeze.
          <br />
          <br />
          With Maker4U, you can have a stunning logo for your business in just minutes. Simply find a logo, customize it to your liking, and download the file.
          <br />
          <br />
          Experience the ease and convenience of our logo maker today and take the first step towards establishing a memorable brand identity.
        </p>
      </div>
    ) : (
      <div>
        <p  className="text-xl md:text-2xl font-semibold mb-4">اصنع شعارًا مذهلاً ببضع نقرات فقط.</p>
        <p style={{ fontSize: "16px" }}>
          في عالم الشركات الناشئة والشركات الجديدة سريع التطور، يعد الوقت أمر جوهري. لذلك، قمنا في Maker4U بتصميم أداة إنشاء الشعارات الخاصة بنا لتكون مجانية وسهلة الاستخدام بشكل لا يصدق. نحن نتفهم الحاجة إلى البساطة والكفاءة، ولهذا السبب كرسنا ساعات غير معدودة لإتقان منصتنا.
          <br />
          <br />
          ببضع نقرات فقط، يمكنك الوصول إلى مكتبتنا الشاملة من نماذج الشعارات وتخصيصها لتناسب شخصية علامتك التجارية. سواء كنت رائد أعمال متمرسًا أو بدأت للتو، فإن واجهتنا البديهية تجعل عملية إنشاء الشعار سهلة.
          <br />
          <br />
          مع Maker4U، يمكنك الحصول على شعار مذهل لشركتك في دقائق معدودة. ما عليك سوى العثور على شعار وتخصيصه حسب رغبتك وتنزيل الملف.
          <br />
          <br />
          جرب سهولة وراحة أداة إنشاء الشعارات الخاصة بنا اليوم واتخذ الخطوة الأولى نحو إنشاء هوية علامة تجارية لا تُنسى.
        </p>
      </div>
    )}
  </div>
</div>


<div className="catlogSectionTwo">
  <div>
    <LazyLoadImage src={`${img46}`} />
  </div>
  <div></div>
  <div
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}
  >
    {isLang === 'eng' ? (
      <div>
        <p  className="text-xl md:text-2xl font-semibold mb-4">How to create that perfect logo</p>
        <p style={{ fontSize: "16px" }}>
          <b>1 - Define your brand:</b> Start by figuring out what makes your brand unique—who you are, what you stand for, and who you're trying to reach.
          <br />
          <b>2 - Research and get inspired:</b> Take a stroll through the world of logos, see what catches your eye, and think about how it could inspire your own design.
          <br />
          <b>3 - Choose a design style:</b> Pick a vibe that fits your brand's personality—whether you're feeling sleek and modern or more laid-back and vintage.
          <br />
          <b>4 - Pick colors and fonts:</b> Time to get creative! Think about the colors and fonts that best represent your brand's vibe and message.
          <br />
          <b>5 - Refine and iterate:</b> Play around with your design until it feels just right—tweak the colors, adjust the layout, and fine-tune those little details.
          <br />
          <b>6 - Test across platforms:</b> Make sure your logo looks good everywhere it's gonna be seen, from your website to your business cards.
          <br />
          <b>7 - Finalize and save:</b> Once you're happy with your design, save it in a few different file formats so you're ready to use it wherever you need to.
        </p>
      </div>
    ) : (
      <div>
        <p className="text-xl md:text-2xl font-semibold mb-4">كيفية إنشاء الشعار المثالي</p>
        <p style={{ fontSize: "16px" }}>
          <b>1 - حدد علامتك التجارية:</b> ابدأ بمعرفة ما يميز علامتك التجارية - من أنت وماذا تمثل ومن تحاول الوصول إليه.
          <br />
          <b>2 - ابحث واستلهم:</b> خذ جولة في عالم الشعارات، وانظر إلى ما يلفت انتباهك، وفكر في كيفية إلهام تصميمك الخاص.
          <br />
          <b>3 - اختر أسلوب التصميم:</b> اختر أسلوبًا يناسب شخصية علامتك التجارية - سواء كنت تشعر بالأناقة والحداثة أو أكثر استرخاءً وعتيقًا.
          <br />
          <b>4 - اختر الألوان والخطوط:</b> حان الوقت للإبداع! فكر في الألوان والخطوط التي تمثل بشكل أفضل أسلوب ورسالة علامتك التجارية.
          <br />
          <b>5 - ارسم وحوّل إلى شكل رقمي:</b> أمسك قلم رصاص وابدأ في رسم أفكارك، ثم اجعلها تنبض بالحياة على جهاز الكمبيوتر الخاص بك أو باستخدام أداة إنشاء الشعارات.
          <br />
          <b>6 - اصقل وكرر:</b> عدل بتصميمك حتى تشعر أنه مناسب تمامًا - عدّل الألوان واضبط التخطيط واضبط التفاصيل الصغيرة.
          <br />
          <b>7 - اختبر عبر المنصات:</b> تأكد من أن شعارك يبدو جيدًا في كل مكان سيتم رؤيته فيه، من موقع الويب الخاص بك إلى بطاقات العمل الخاصة بك.
          <br />
          <b>8 - الانتهاء والحفظ:</b> بمجرد رضاك عن التصميم، احفظه في عدة تنسيقات ملفات مختلفة حتى تكون جاهزًا لاستخدامه أينما تحتاج إليه.
        </p>
      </div>
    )}
  </div>
</div>


<div className="catelogAITexContainer">
  <div className="catelogAIText"
    style={{
      textAlign: isLang === 'eng' ? 'left' : 'right',
      direction: isLang === 'eng' ? 'ltr' : 'rtl',
    }}>
    {isLang === 'eng' ? (
      <>
        <p>Transform Your Brand: Create Your Logo Today</p>
        <p style={{ fontSize: "16px" }}>
          Empower your brand's identity with Maker4u Logo Maker. Craft a distinctive logo that captures your essence effortlessly. Explore a plethora of design options tailored to your vision. With intuitive tools and endless creativity at your fingertips, redefine your brand image today. Start your journey towards brand transformation now.
        </p>
      </>
    ) : (
      <>
        <p className="text-center">حوّل علامتك التجارية: أنشئ شعارك اليوم</p>
        <p style={{ fontSize: "16px" }}>
          عزّز هوية علامتك التجارية باستخدام Maker4u Logo Maker. أنشئ شعارًا مميزًا يعكس جوهر علامتك بسهولة. استكشف مجموعة متنوعة من خيارات التصميم التي تتماشى مع رؤيتك. مع الأدوات المبتكرة والإبداع اللامتناهي، أعد تعريف صورة علامتك اليوم. ابدأ رحلتك نحو تحويل العلامة التجارية الآن.
        </p>
      </>
    )}
  </div>
</div>

<div className="cardContainer">
  <div>
    <div>
      <LazyLoadImage src={`${img7}`} />
    </div>
    <div
      style={{
        textAlign: isLang === 'eng' ? 'left' : 'right',
        direction: isLang === 'eng' ? 'ltr' : 'rtl',
      }}>
      {isLang === 'eng' ? (
        <>
          <p>1. Include Media</p>
          <p style={{ fontSize: "16px" }}>
            Compile images or movies from stock libraries or computers into the scenario. Add some effects if you like as well.
          </p>
        </>
      ) : (
        <>
          <p>1. أضف الوسائط</p>
          <p style={{ fontSize: "16px" }}>
            قم بتجميع الصور أو الأفلام من مكتبات الوسائط أو الكمبيوتر في المشهد. يمكنك إضافة بعض التأثيرات أيضًا إذا كنت ترغب.
          </p>
        </>
      )}
    </div>
  </div>

  <div>
    <div>
      <LazyLoadImage src={`${img8}`} />
    </div>
    <div
      style={{
        textAlign: isLang === 'eng' ? 'left' : 'right',
        direction: isLang === 'eng' ? 'ltr' : 'rtl',
      }}>
      {isLang === 'eng' ? (
        <>
          <p>2. Personalize</p>
          <p style={{ fontSize: "16px" }}>
            For more customization, add narration, music, and text to your advertisement. Choose different styling fonts and bright colors.
          </p>
        </>
      ) : (
        <>
          <p>2. خصص</p>
          <p style={{ fontSize: "16px" }}>
            لإضفاء المزيد من التخصيص، أضف سردًا صوتيًا، وموسيقى، ونصًا إلى إعلانك. اختر خطوطًا أنيقة وألوانًا زاهية.
          </p>
        </>
      )}
    </div>
  </div>

  <div>
    <div>
      <LazyLoadImage src={`${img9}`} />
    </div>
    <div
      style={{
        textAlign: isLang === 'eng' ? 'left' : 'right',
        direction: isLang === 'eng' ? 'ltr' : 'rtl',
      }}>
      {isLang === 'eng' ? (
        <>
          <p>3. Export</p>
          <p style={{ fontSize: "16px" }}>
            You may share your promotional media on the internet or download it in different resolutions and ratios by clicking the download option and exporting it to your computer or sharing it on any platform.
          </p>
        </>
      ) : (
        <>
          <p>3. التصدير</p>
          <p style={{ fontSize: "16px" }}>
            يمكنك مشاركة الوسائط الترويجية الخاصة بك على الإنترنت أو تحميلها بتنسيقات ونسب أبعاد مختلفة عن طريق النقر على خيار التنزيل وتصديرها إلى جهاز الكمبيوتر الخاص بك أو مشاركتها على أي منصة.
          </p>
        </>
      )}
    </div>
  </div>
</div>

      <Footer />
    </>
  );
};

export default LogoMaker;
